// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IHoqq","index":"styles_index__mqTF7"};